// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","687":"fea29d9f","945":"d9067523"}[chunkId] || chunkId) + "-" + {"245":"b8299c2232dc74565d51","452":"c8673476071a3ffaee78","454":"f9b8527dac18c2dbea61","551":"047980fdd6540280ac61","687":"c9db220f34eaff0bc815","945":"a11074b2a436f1ef23cc"}[chunkId] + ".js";
};